// extracted by mini-css-extract-plugin
module.exports = {"countdown":"cf-z","srOnly":"df-z"};